export default {
  notifications: []
};
